import React, {useEffect} from "react";
import {useDispatch} from "react-redux";

import subscriptionActions from "./subscriptionActions";

export function useSubscription(name, url, intervalSeconds, initialWait = 0, staleAfterSeconds = 5 * 60) {
    const dispatch = useDispatch();
    useEffect(() => {
        if (url) {
            const subscription = subscriptionActions(dispatch).subscribe(url, name, intervalSeconds, initialWait, staleAfterSeconds);
            return () => {
                subscription.unsubscribe();
            };
        }
    }, [url]);
}
